export enum ReviewsAnalyticsMessages {
  event = 'button click',
  capability = 'shared services',
  thumbsUp = 'app review:thumbs up',
  thumbsDown = 'app review:thumbs down',
}
